import React, { forwardRef, useLayoutEffect } from 'react'
import Konva from 'konva'
import { Image } from 'react-konva'
import { useQRCodeImage } from '../../hooks'

type Props = { code: string; size?: number; onLoaded?: (image: HTMLImageElement) => void } & Omit<
  Konva.ImageConfig,
  'image'
>

export const QRCode = forwardRef(({ code, size = 200, onLoaded, ...imageConf }: Props, ref) => {
  const image = useQRCodeImage(code, size)

  useLayoutEffect(() => {
    if (image) onLoaded?.(image)
  }, [image, onLoaded])

  if (!image) return null

  return <Image {...imageConf} image={image} ref={ref as any} />
})
